import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";

import $ from "jquery";
import {
  getAxiosResponse,
  postAxiosResponse,
  postAxiosFormDataResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { addDaysToDate, getDateDifference, timeStamp } from "../../../services/Util";
import Constants from "../../../Constants";
import { currentDateWithFormat } from "../../../services/Util";
import { transformBlankToNull } from "../../../services/Util";
import CustomProgressBar from "../../global/CustomProgressBar";
import axios from "axios";
import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import dateUtil from "../../../services/DateUtil";
import store from "../../../redux/store";
import DateFormat from "../../../pages/DateFormat";
import { FileIcon } from "../../../AppIcons";

const chunkSize = Constants.CHUNK_SIZE;;

export default function ProjectCustomTaskForm(prop) {
  const projectId = prop.id;
  const { t } = useTranslation();
  const translate = t;
  const inputRef = useRef(null);
  const [toggle, toggleCal] = useState(false);
  const [toggle1, toggleCal1] = useState(false);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedAssignedUser, setSelectedAssignedUser] = useState("");
  const [selectedNotifyUser, setSelectedNotifyUser] = useState([]);
  const [showNotificationUsers, setShowUsers] = useState([]);
  const refToggle = useRef(null);
  const refToggle1 = useRef(null);
  const refCalendar1 = useRef(null);
  const refCalendar = useRef(null);
  const [users, setUsers] = useState([]);
  const [validation, setValidation] = useState(true);
  const [notifyUsers, setNotifyUsers] = useState([]);
  // const [languageFilter, setLanguageFilter] = useState([]);
  const [selectedLanguages, setLanguage] = useState("");
  const [selectedfile, setSelectedFile] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [reminderDay, setReminderDay] = useState("");
  const [allowReminder, setAllowReminder] = useState(false);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [documentFileId, setDocumentFileId] = useState(-1);
  const [hasDocument, setHasDocument] = useState(true);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [reminderDateStatus,setReminderStatus]=useState(false);
  const customerRedux = store.getState()?.customer_bootstrap_data?.value;
  const customerTimeZone = customerRedux?.user?.timeZone;
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
 

  const checkValidation = (event) => {
    if (taskName === "" || selectedAssignedUser === "") {
      setValidation(false);
    } else {
      setValidation(true);
    }
  };
  const addTagSelectAttrb = (e) => {
    setTimeout(() => {
      $(".MuiList-root").find("li").first().css("opacity", 0);
      $(".MuiList-root").attr("aria-label", "Tag list");
      $.each($(".MuiMenuItem-root"), function (index, value) {
        $(value).find("input").css("display", "none");
      });
    }, 200);
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 4;
  const TagMenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
        color: aaaSelected ? "white" : "#1C233C",
        background: aaaSelected ? "black" : "#FFF",
        fontSize: "85.71429%",
      },
    },
  };
  const showCalendarStartDate = (event) => {
    toggle ? toggleCal(false) : toggleCal(true);
    $('#calFirstFocus').toggleClass('calFirstFocus')
    $('.calFirstFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.firstCal');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          toggleCal(false)
          $('#calFirstFocus').removeClass('calFirstFocus')
     }
    });
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  };
  $("#calFirstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendar')){
        toggleCal(false)
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendar')){
        toggleCal(false)
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
    });
    
   const handleEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      toggleCal(false)
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
    }
  }
  const showCalendarDueDate = (event) => {
    toggle1 ? toggleCal1(false) : toggleCal1(true);
    $('#calSecondFocus').toggleClass('calSecondFocus')
    $('.calSecondFocus').trigger('focus')
   $(document).mouseup(function(e) {
      var bannerCont = $('.caltopset');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal1(false)
        $('#calSecondFocus').removeClass('calSecondFocus')
     }
     });
    if (toggle1) {
      var requiredElement = document.querySelector(".dashCalendar1");
      requiredElement.focus();
    }
  };
 
  $("#calSecondFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendar1')){
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
       }
     }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendar1')){
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
       }
     }
   });
   const handleEscFocus2 = (event) => {
    if (event.key === Constants.ESCAPE) {
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
    }
  }
  const removeItem = (id) => {
    setShowUsers((current) =>
      current.filter(
        (showNotificationUsers) => showNotificationUsers.value !== id
      )
    );
    let removedUser = allUsers.find((user) => user.value === id);
    setNotifyUsers((current) => [...current, removedUser]);
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".wrap-dropdown").find('.global-dropdown-block input:first-of-type').trigger('focus');
    }
  };
  const setReminder = (e) => {
    setAllowReminder(e.target.checked);
    if (e.target.checked === false) {
      $("#task-email-reminder-day").val("");
    }
  };
  const handleReminderDay = (event) => {
    setReminderStatus(false);
    var element = $("#emailReminderDay");
    element.val(element.val().replace(/[^0-9\.]/g, ""));
    setReminderDay(event.target.value);
    if(getDateDifference(startDate,dueDate) < event?.target?.value){
      setReminderStatus(true);
    }
  };
  useEffect(() => {
    inputRef.current.focus();
    getAxiosResponse(APIUrls.PROJECT_FOLLOWER_USER(projectId))
      .then((res) => {
        if (res.data.code === 200) {
          const users = res.data.data.map(({ resource, displayName }) => {
            const { userId, firstName, lastName } = resource;
            const role = displayName[0]?.roles[0];
            return {
              value: userId,
              label: `${firstName} ${lastName} (${role})`,
            };
          });
          setFollowers(users);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId))
      .then((res) => {
        if (res.data.code === 200) {
          const users = res.data.data.map(({ resource, displayName }) => {
            const { userId, firstName, lastName } = resource;
            const role = displayName[0].displayName;
            return {
              value: userId,
              label: `${firstName} ${lastName} (${role})`,
              isVendor: false,
            };
          });
          users.sort((a, b) => a.label.localeCompare(b.label));
          if(projectData.vendor && projectData.vendor.machineTranslationVendor === false && projectData.vendor.isInternal === false){
            users.push({
              value: projectData.vendor.id,
              label: `${projectData.vendor.name} (Vendor)`,
              isVendor: true
            });
          }
          setAllUsers(users);
          var followers = [
            {
              key: "0",
              value: "all-follower",
              label: "Select All Project Followers",
            },
            {
              key: "1",
              value: "other-dept-users",
              label: "Other Users In Department",
            },
            ...users,
          ];
          setNotifyUsers(followers.filter((user) => user.value !== projectData.owner.userId));
        }
      })
      .catch((err) => {
        handleError(err);
      });
      setShowUsers([{value: projectData.owner.userId,
        label: `${projectData.owner.firstName} ${projectData.owner.lastName} (${projectData.owner.roleSet.displayName})`,}]);
  }, []);

  const handleAssignedUserChange = (event) => {
    setSelectedAssignedUser(event.isVendor ? "-"+event.value:event.value);
  };
  const handleNotifyUserChange = (event) => {
    var selectedId = event.value;
    if (event.value === "all-follower") {
      setShowUsers(followers);
    } else if (event.value === "other-dept-users") {
      setShowUsers(allUsers);
    } else {
      const result = allUsers.find(({ value }) => value == selectedId);
      setShowUsers((current) => [...current, result]);
      }
    setNotifyUsers(notifyUsers.filter((user) => user.value !== event.value));
    setSelectedNotifyUser((current) => [...current, event.value]);
  };

  const handleLanguageChange = (event) => {
    var selectedLang = event.value;
    setLanguage(selectedLang);
  };
  const selectStartDate = (event) => {
    setDueDate('')
    setStartDate(event);

    refToggle.current.focus()
    toggleCal(false)
    $('.calFirstFocus').trigger('focus')
    $('#calFirstFocus').removeClass('calFirstFocus')

  };
  const selectDueDate = (event) => {
    setDueDate(event);

    refToggle1.current.focus()
    toggleCal1(false)
    $('.calSecondFocus').trigger('focus')
    $('#calSecondFocus').removeClass('calSecondFocus')

  };
  
  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleCal(false);
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
    }
  };
  const closeCalendar2 = (e) => {
    if (e.code === "Escape") {
      toggleCal1(false);
      $('.calSecondFocus').trigger('focus')
       $('#calSecondFocus').removeClass('calSecondFocus')
    }
  };
  function fileSelection(e) {
    if (e.target?.files?.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  }
  const createTask = () => {
    checkValidation();
    let taskData = {
      type: "custom",
      displayName: taskName,
      description: taskDescription,
      currentAssignee: selectedAssignedUser,
      targetLanguage: "English",
      startDate: timeStamp(startDate,customerTimeZone),
      dueDate: timeStamp(dueDate,customerTimeZone),
      project: { id: projectId },
      hasDocument: "false",
      workspace: {},
    };
    if (allowReminder) {
      taskData.emailReminderDay = reminderDay;
    } else {
      taskData.emailReminderDay = null;
    }
    if (selectedfile !== "") {
      taskData.hasDocument = "true";
    } else {
      taskData.hasDocument = "false";
    }

    if (taskName !== "" && selectedAssignedUser !== "") {
      setHasDocument(taskData.hasDocument);
      taskData = transformBlankToNull(taskData);
      postAxiosResponse(APIUrls.CAMPAIGN_CUSTOM_TASK, taskData)
        .then((res) => {
          if (res.status === 200) {
            let documentFileId = -1;
            if (res?.data?.data?.documentFileId) {
              documentFileId = res?.data?.data?.documentFileId;
              setDocumentFileId(documentFileId);
            }
            if (documentFileId === -1) {
              setCurrentChunkIndex(0);
            } else {
              setShowProgress(true);
              setCurrentChunkIndex(0);
            }
          }
        })
        .catch((err) => {
          handleError(err);
        });
    }
  };
  const resetfelds = () => {
    prop.funct(false);
  };
  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  function readAndUploadCurrentChunk() {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  }

  function getParams(file) {

    const params = new URLSearchParams();
    if (file) {
      params.set("name", file.name);
      params.set("size", file.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(file.size / chunkSize));
    }
    params.set("displayName", taskName);
    params.set("description", taskDescription);
    params.set("currentAssignee", selectedAssignedUser);
    params.set("targetLanguage", selectedLanguages);
    params.set("projectId", projectId);
    params.set("hasDocument", hasDocument);
    params.set("emailReminderDay", reminderDay !== "" ? reminderDay : "");
    params.set("sendEmailReminder", "true");

    showNotificationUsers.forEach((id) => {
      if(id.isVendor){
        params.append("vendorFollower", id.value);
      }else{
        params.append("customerFollower", id.value);
      }
    }); 

    params.set("startDate", dateUtil.format(startDate, Constants.DATE_FORMAT_D_M_YYYY, null));
    params.set("dueDate",dateUtil.format(dueDate, Constants.DATE_FORMAT_D_M_YYYY, null));
    params.set("documentFileId", documentFileId !== -1 ? documentFileId : "");
    return params;
  }

  function uploadChunk(readerEvent) {
    //for testing purpose
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const params = getParams(file);
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const urlPart = file
      ? APIUrls.UPLOAD_ASSET_ATTACHMENT
      : APIUrls.UPLOAD_ASSET_ATTACHMENT.replace("/upload", "");
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}?` + params.toString();
    axios.post(url, data, { headers }).then((response) => {
      if (selectedfile) {
        const filesize = selectedfile.size;
        const chunks = Math.ceil(filesize / chunkSize) - 1;
        const isLastChunk = currentChunkIndex === chunks;
        if (isLastChunk) {
          setCurrentChunkIndex(null);
          setFileUploadProgress(100);
          setTimeout(() => {
            prop.funct(false);
          }, 1000);
        } else {
          const chunks = Math.ceil(filesize / chunkSize);
          setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
          setCurrentChunkIndex(currentChunkIndex + 1);
        }
      } else {
        setCurrentChunkIndex(null);
        setTimeout(() => {
          prop.funct(false);
        }, 1000);
      }
    });
  }
  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      $(value).attr('aria-label', value.children[0].ariaLabel);
    });
  });
   $(document).ready(function(){
    $(".requiredClass .cw__input").attr({
      "aria-describedby":"user-error",  
      'aria-required':'true'
    });
    if($('div').hasClass('taskNameFocus')){
      $('#task_name').trigger('focus')
    }
    if($('div').hasClass('userError')){
      $('.requiredClass .cw__input').trigger('focus')
      
    }
   })
  

  return (
    <div className="task-form-content">
      <div className="form-group">
        <div className="form-text">
          <label htmlFor="task_name">Task name:</label>
          <br />
          <input
            type="text"
            id="task_name"
            aria-required='true'
            name="taskName"
            className="form-control-sm"
            aria-describedby="taskNameFocus"
            ref={inputRef}
            onChange={(event) => setTaskName(event.target.value)}
          />
          {!validation && taskName === "" ? (
            <div id="taskNameFocus" className="error taskNameFocus">
              Task name required
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="form-group">
        <div className="form-text">
          <label className="optional-right" htmlFor="DescMassage">
            Description <span>(Optional)</span>
          </label>
          <textarea
            className="textarea form-control-sm"
            placeholder="1000 characters limit"
            maxLength={1000}
            id="DescMassage"
            onChange={(event) => setTaskDescription(event.target.value)}
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">Select User</h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>Assigned To</label>
            <div className="global-dropdown-select requiredClass">
              <Select classNamePrefix='cw'
                className="global-dropdown-select"
                value={allUsers.filter(function (option) {
                  return option.value === selectedAssignedUser || "-"+option.value === selectedAssignedUser;
                })}
                aria-label="Assigned To"
                options={allUsers}
                onChange={(e) => handleAssignedUserChange(e)}
              />
            </div>
            {!validation && selectedAssignedUser === "" ? (
              <div id="user-error" className="error userError">
                Please select a user
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center">
            <label>Who will receive notifications about this task?</label>
            <div className="global-dropdown-select">
              <Select classNamePrefix='cw'
                className="global-dropdown-select"
                value={notifyUsers.filter(function (option) {
                  return option.value === selectedNotifyUser;
                })}
                aria-label="Who will receive notifications about this task"
                options={notifyUsers}
                onChange={(e) => handleNotifyUserChange(e)}
              />
            </div>
            <div className="multiselect-output flex">
              {showNotificationUsers.map((user, index) => {
                return (
                  <button key={index} onClick={() => removeItem(user.value)} aria-label={'remove ' + user.label}>
                    <strong> {user.label}
                    </strong>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path
                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                        stroke="#213248"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform border-bottom">
          Language and Attachements <span>(Optional)</span>
        </h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>Task Language</label>
            <div className="global-dropdown-select">
              <Select classNamePrefix='cw'
                className="global-dropdown-select"
                value={prop.taskLangs.filter(function (option) {
                  return option.value === selectedLanguages;
                })}
                aria-label="Task Language"
                options={prop.taskLangs}
                onChange={(e) => handleLanguageChange(e)}
              />
            </div>
          </div>
          <div className="global-dropdown-block flex-center">
            <label>Add Attachment</label>

            <div className="file-input flex">
              <div className="input-file mb-0">
                <input type="file" id="files" onChange={fileSelection} />
                <label className="file-button flex-center" htmlFor="files">
                  {!selectedfile ? "Choose file" : "or select to replace"}
                </label>
              </div>
             
            </div>
          </div>
          <div className="w-d100">
          <div className={ selectedfile ? "uploading-files-block uploading-success mar-top6 wd-50" : "uploading-files-block uploading-success mar-top6 wd-50 hide"}>
                <div className="uploading-file-list flex">
                  <div className="left-file-desc flex-center">
                    <div className="icon-block">
                      {FileIcon}
                    </div>
                    <div className="file-text">
                      <span className="ext-name">{selectedfile?.name}</span>
                      <strong>
                        <span className="date-name"><DateFormat date={new Date()} format={null} timezone={null}/></span>
                        <span className="file-size">
                          {formatBytes(selectedfile?.size)}
                        </span>
                      </strong>
                    </div>
                  </div>
                </div>
                <div className={ showProgress ? "right-progressbar" : "right-progressbar hide" }>
                  <CustomProgressBar
                    completed={fileUploadProgress}
                    labelLineHeight="1px"
                    labelSize="14px"
                    width="100%"
                    labelClassName="progressBarLabel"
                    borderRadius="30px"
                    labelAlignment="outside"
                    labelColor="rgba(0,0,0,0.87)"
                    height="10px"
                    className="file_upload_progress"
                    bgColor="#06B878"
                    baseBgColor="#D1DEF0"
                    ariaValuetext={fileUploadProgress}
                    aria-label=""
                    aria-valuenow={fileUploadProgress}
                  />
                </div>
              </div>
            </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">
          Task Dates <span>(Optional)</span>
        </h6>
        <div className="flex wrap-dropdown flex-basline">
          <div className="global-dropdown-block flex-center firstCal">
            <label htmlFor='calFirstFocus'>{translate("task_campaign.start_date")}</label>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarStartDate(e);
                }}
                onKeyDown={(e) => handleEscFocus(e)}
                ref={refToggle}
                aria-expanded={toggle ? 'true':'false'}
                aria-label={toggle ? 'choose date dialog': startDate !== ""? `task start date ${dateUtil.format(startDate,null,null)} selected` :""}
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
                id='calFirstFocus'
              >
                <span>{startDate !== ""? dateUtil.format(startDate,null,null) :""}</span>
                <span className="font-zero">{startDate !== ""? `${dateUtil.format(startDate,null,null)} selected` :"Start Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
              
            </div>
            {toggle ? (
              <div ref={refCalendar}
                
                onKeyDown={(e) => {
                  closeCalendar(e);
                }}
              >
                <DatePickerCalendar
                 defaultValue={ new Date()}
                 className="dashCalendar"
                 minDate={new Date()}
                 selectDate={selectStartDate}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center caltopset">
            <label htmlFor='calSecondFocus'>Due Date</label>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarDueDate(e);
                }}
                onFocus={()=>toggleCal(false)}
                onKeyDown={(e) => handleEscFocus2(e)}
                ref={refToggle1}
                id='calSecondFocus'
                aria-expanded={toggle1 ? 'true':'false'}
                aria-label={toggle1 ? 'choose date dialog': dueDate !== ""? `task due date ${dateUtil.format(dueDate,null,null)} selected` :""}
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
              >
                <span>{dueDate !== ""? dateUtil.format(dueDate,null,null) :""}</span>
                <span className="font-zero">{dueDate !== ""? dateUtil.format(dueDate,null,null) :"Due Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
            </div>
            {toggle1 ? (
              <div
                ref={refCalendar1}
                onKeyDown={(e) => {
                  closeCalendar2(e);
                }}
              >
                <DatePickerCalendar
                 defaultValue={ new Date()}
                 className="dashCalendar1"
                 minDate={new Date(addDaysToDate(startDate,1,''))}
                 selectDate={selectDueDate}
                />
              </div>
            ) : (
              ""
            )}


            <div className="form-check-outer">
              <div className="form-check small-checkbox">
                <input
                  type="checkbox"
                  id="remind_assignee"
                  disabled={dueDate === "" ? true : false}
                  onChange={setReminder}
                />
                <label htmlFor="remind_assignee">Remind Assignee</label>
              </div>
              <div className="form-number flex-center">
                <input
                  type="text"
                  id="emailReminderDay"
                  name="emailReminderDay"
                  maxLength={2}
                  className="form-control-sm"
                  disabled={!allowReminder}
                  onChange={handleReminderDay}
                />
                <label htmlFor="emailReminderDay" aria-label="Days before due date">
                  Days before due date 
                </label>
              </div>
          {reminderDateStatus ? <span className="textDanger">Reminder date must be in the future</span> : ""} 
            </div>
            
          </div>
         
        </div>
        <div className="flex justify-end btn-gap">
          <button className="btn btn-bold" onClick={createTask} disabled={taskName === "" || selectedAssignedUser === "" || reminderDateStatus}>
            Create Task
          </button>
          <button className="btn btn-bold" onClick={resetfelds}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
